import ApiService from "../../services/ApiService";
import Logger from "../../services/Logger";

const AdminAppReviewService = {
    list: async (page = 0, pageSize = 25) => {
        try {
            const response = await ApiService.getData("/v1/app-review", { page, pageSize });
            return {
                success: true,
                data: response
            };
        } catch (error) {
            Logger.error("Error fetching app review prompts:", error);
            return {
                success: false,
                error: error.message || "Failed to fetch review prompts"
            };
        }
    },

    forUser: async (cloudUserId, appCode = "word_wheel_quest") => {
        try {
            const response = await ApiService.getData(`/v1/app-review/user/${cloudUserId}`, { appCode });
            if (response && Object.prototype.hasOwnProperty.call(response, "review")) {
                return {
                    success: true,
                    data: response
                };
            }
        } catch (error) {
            Logger.error("Error fetching user app review:", error);
        }
        try {
            const listed = await ApiService.getData("/v1/app-review", { page: 0, pageSize: 100 });
            const content = Array.isArray(listed?.content) ? listed.content : [];
            const review = content.find((row) =>
                String(row?.cloudUserId) === String(cloudUserId) && row?.appCode === appCode
            ) || null;
            return {
                success: true,
                data: { review }
            };
        } catch (error) {
            Logger.error("Error fetching user app review from list:", error);
            return {
                success: false,
                error: error.message || "Failed to fetch review"
            };
        }
    },

    remove: async (id) => {
        try {
            const response = await ApiService.deleteData(`/v1/app-review/${encodeURIComponent(id)}`);
            return {
                success: true,
                data: response
            };
        } catch (error) {
            Logger.error("Error removing app review prompt:", error);
            return {
                success: false,
                error: error.message || "Failed to remove review prompt"
            };
        }
    }
};

export default AdminAppReviewService;
